module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"Codeeta","payTtl":"Captan clientes y venden online de forma sencilla y sin necesidad de programar.","payText":" ","payBtn":"MÁS INFORMACIÓN"},"es":{"payTitulo":"Codeeta","payTtl":"Captan clientes y venden online de forma sencilla y sin necesidad de programar.","payText":" ","payBtn":"MÁS INFORMACIÓN"}}')
  delete Component.options._Ctor
}
